<template>
  <login-component @prompt="promptAnswer" />
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    promptAnswer(data) {
      this.$store
        .dispatch(data.action, data, { root: true })
        .then(() => {
          this.$notify({
            group: "login",
            title: this.selectedLanguage.lgAuthSuccessTitle,
            type: "success",
            text: this.selectedLanguage.lgAuthSuccessMsg,
          });

          this.$router.push({ name: "Home" });
        })
        .catch(() => {
          this.$notify({
            group: "login",
            title: this.selectedLanguage.lgAuthFailTitle,
            type: "error",
            text: this.selectedLanguage.lgAuthFailMsg,
          });
        });
    },
  },
  computed: {
    selectedLanguage() {
      return this.$store.state.langs.language;
    },
  },
};
</script>

<style></style>
